import { render, staticRenderFns } from "./add-item.vue?vue&type=template&id=9de1c19a&"
import script from "./add-item.vue?vue&type=script&lang=js&"
export * from "./add-item.vue?vue&type=script&lang=js&"
import style0 from "./add-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports